import React               from 'react';
import { Link }            from 'react-router-dom';
import Alert               from '../../shared/alert';
import LoaderButton        from '../../shared/loader-button/loader-button.jsx';
import PasswordHelper      from '../../shared/password-helper-input/password-helper.jsx';
import LocaleString        from '../../shared/locale-string';
import { CloseCircleIcon } from '../../shared/icons/icons.jsx';

import './reset-password.scss';

class ResetPassword extends React.Component {
    constructor( props ) {
        super( props );
        this.state = {
            password: ''
        };
    }

    componentWillUnmount() {
        this.props.errors.forEach( error => this.props.dismissError( error ) );
    }

    handleInputChange = event => {
        const name = event.target.name;
        this.setState( { [ name ]: event.target.value } );
    };

    onResetPasswordSubmit = () => {
        const { password } = this.state;
        const {
            savePassword,
            errors,
            dismissError,
            passwordGuid
        } = this.props;

        errors.forEach( error => dismissError( error ) );
        savePassword( password, passwordGuid );
    };

    checkEnter = event => {
        const enterPressed = event.charCode === 13;
        const { password } = this.state;

        if ( enterPressed && password.length ) {
            this.onResetPasswordSubmit();
        }
    };

    render() {
        const {
            password
        } = this.state;
        const {
            dismissError,
            success,
            errors,
            busy,
            passwordRules,
            passwordLabels,
            successMessage,
            backLabel
        } = this.props;

        return (
            <div className="reset-password">
                <div className="narrow-form">

                    <div className="title" >
                        <Link className="back" to="/login" style={ { color: 'white' } } aria-label={ backLabel } >
                            <CloseCircleIcon />
                        </Link>
                        <h2><LocaleString code="resetPassword.form.headerLabel" /></h2>
                    </div>

                    <PasswordHelper
                        id="password"
                        label={ <LocaleString code="resetPassword.input.newPasswordLabel" /> }
                        name= "password"
                        value= { password }
                        disable= { success }
                        tabIndex="2"
                        onChange={ this.handleInputChange }
                        onKeyPress={ this.checkEnter }
                        passwordRules={ passwordRules }
                        passwordLabels={ passwordLabels } />

                    {
                        errors.length !== 0 && errors.map( ( error, index ) =>
                            <Alert type={ 'error' } onDismiss={ () => dismissError( error ) } key={ index }>
                                <p>{ error.responseMessage || error.message }</p>
                            </Alert>
                        )
                    }

                    {
                        successMessage.length !== 0 && <Alert type={ 'success' }>
                            <Link to="/login" style={ { color: 'white' } }>
                                <LocaleString code={ successMessage[ 0 ].message } />
                            </Link>
                        </Alert>
                    }

                    <LoaderButton
                        busy={ busy }
                        onClick={ this.onResetPasswordSubmit }
                        disabled={ !password.length || success }
                        tabIndex="3"
                        done={ success }>
                        <LocaleString code="resetPassword.button.submitLabel" />
                    </LoaderButton>

                </div>
            </div>
        );
    }
}
export default ResetPassword;
